import React, { useContext } from 'react';

import { ChartTopBar } from 'components/Chart';
import DashboardGadgetBottomBar from 'components/DashboardGadgetBottomBar';
import StudioEChartContainer from 'components/StudioCharts';
import CanvasCard from 'components/Visualisations/CanvasCard';
import DashboardGadgetContext from 'contexts/DashboardGadgetContext';

// A bullet chart on a dashboard or wallboard: drawn with ECharts, as only
// it can draw one (see isDrawnOnlyWithECharts), whatever Studio's gate says
const BulletContainer = ({
  chartDefinition,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  useSmallNoDataMessage: boolean;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <CanvasCard
      topBar={<ChartTopBar chartDefinition={chartDefinition} />}
      content={
        <StudioEChartContainer
          chartDefinition={chartDefinition}
          useSmallNoDataMessage={useSmallNoDataMessage}
        />
      }
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
    />
  );
};

export default BulletContainer;
